import type { CityConfig } from "@/pages/city-template/types";

export const commackConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Commack",
  state: "New York",
  stateAbbr: "NY",
  slug: "commack",
  route: "/commack",
  title: "Emergency Passport Commack, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Commack, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Central Suffolk County, split school district families, LIE corridor professionals, and all Commack communities.",
  h1: "Emergency & Expedited Passport Services in Commack, NY",
  heroSubtitle: "Long Island Expressway commute to Manhattan office where you just booked a JFK flight to London next week — and your passport is expired? Split school district spring break — half the family going to Cancun and half to Punta Cana on different dates and nobody checked passport validity? Commack Motor Inn area professional with a last-minute client meeting in Toronto? We help Commack residents — from the LIE corridor business community to the Smithtown/Huntington school district families to the Dix Hills border neighborhoods — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20Commack%20New%20York%20suburban%20neighborhood%20at%20golden%20hour%2C%20tree-lined%20streets%20with%20well-maintained%20homes%20and%20green%20lawns%2C%20Central%20Suffolk%20County%20suburban%20community%20with%20Long%20Island%20Expressway%20corridor%2C%20warm%20afternoon%20sunlight%20filtering%20through%20mature%20trees%2C%20professional%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%20or%20signs%2C%20peaceful%20residential%20scene%20with%20blue%20sky%20and%20quiet%20streets&width=1800&height=700&seq=commack-hero-2026-06&orientation=landscape",
  heroImageAlt: "Commack New York suburban neighborhood with tree-lined streets and Long Island Expressway corridor at golden hour",
  geoPosition: "40.8429;-73.2929",
  geoPlacename: "Commack, New York, United States",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "About 30 miles via Long Island Expressway or LIRR — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Commack", zips: "11725" },
    { name: "Smithtown", zips: "11745, 11754, 11780, 11787, 11788" },
    { name: "Hauppauge", zips: "11749, 11760, 11788" },
    { name: "Dix Hills", zips: "11746" },
    { name: "Kings Park", zips: "11754" },
    { name: "Northport", zips: "11768" },
    { name: "East Northport", zips: "11731" },
    { name: "Greenlawn", zips: "11740" },
    { name: "Huntington", zips: "11743, 11721, 11740, 11746, 11747, 11750" },
    { name: "Melville", zips: "11747, 11775" },
    { name: "Plainview", zips: "11803" },
    { name: "Syosset", zips: "11773, 11791" },
    { name: "Islip", zips: "11751, 11752" },
    { name: "Bay Shore", zips: "11706, 11769" },
    { name: "Brentwood", zips: "11717" },
    { name: "Long Island", zips: "11001-11980" },
    { name: "New York City", zips: "10001-10282" },
  ],
  benefits: [
    { icon: "ri-roadster-line", title: "Long Island Expressway (LIE) Corridor Hub", desc: "Commack sits at the junction of the LIE and Sunken Meadow Parkway — the crossroads of Central Suffolk County. Professionals commuting to NYC book international flights and often discover passport issues with just days to spare." },
    { icon: "ri-building-2-line", title: "Hauppauge & Melville Business Proximity", desc: "Commack borders two of Long Island's largest office parks — the Hauppauge Industrial Park and Melville business corridor. Corporate travelers from both districts rely on Commack as their residential base with courier-speed passport access." },
    { icon: "ri-school-line", title: "Split School District Families", desc: "Commack's unique position straddling Smithtown and Huntington school districts creates families with staggered spring break and summer vacation schedules — requiring passport coordination across different travel dates and destinations." },
    { icon: "ri-parent-line", title: "Suburban Family Travel Hub", desc: "Commack's concentration of young families means a high volume of first-time child passport applications, multi-generational trips, and first-time international travel — all requiring in-person acceptance clerk visits at nearby facilities." },
  ],
  internalLinks: [
    { name: "Fast passport services in Smithtown, NY", route: "/smithtown" },
    { name: "Expedited passport in Huntington, NY", route: "/huntington" },
    { name: "Quick passport services in Dix Hills area", route: "/islip" },
    { name: "Urgent passport services in Long Island", route: "/long-island" },
    { name: "New York passport services overview", route: "/newyork" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Commack via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street — about 30 miles away. Commack's central location on the LIE means the agency is technically accessible in under an hour, but appointments are extremely scarce. Our registered couriers hand-deliver your documents — meaning faster results without the appointment wait. Commack residents can ship from any UPS Store, FedEx Office, or post office location across Central Suffolk County.",
  fpcOfficeDistance: "Serving Commack, Smithtown, Hauppauge, Dix Hills, and all Central Suffolk County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Commack and Central Suffolk County. From the LIE corridor business community to the split-district family neighborhoods, from the Dix Hills border to the Hauppauge business park — we serve the geographic and commercial crossroads of Long Island. Our courier service eliminates the need to travel 30 miles to Manhattan for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Commack and all surrounding Central Suffolk County communities including Smithtown, Hauppauge, Dix Hills, Kings Park, East Northport, and Melville. We also serve travelers departing from JFK, LaGuardia, and Long Island MacArthur Airport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Commack as simple as possible — with the efficiency and reliability LIE corridor professionals, split-district families, and Hauppauge business travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you. Most Commack travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Commack travelers encounter unique passport issues — everything from split school district spring break passport coordination to LIE commuter passport discoveries to first-time family applications. Here are the most common mistakes.",
  testimonialsIntro: "Commack travelers — from LIE corridor professionals to split-district families to Hauppauge business park employees — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Commack, NY? Here are the most common ones we hear from Central Suffolk County travelers.",
  statePageRoute: "/states/newyork",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a JFK departure from the LIE corridor, an emergency passport for a Hauppauge business meeting, or first-time passports for a Commack family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier, we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for LIE corridor professionals and family travelers", "Document review included", "Dedicated agent assigned", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service at Commack post office", "Good for planned international travel", "Document review included", "Dedicated agent assigned", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment at Commack post office required", "No document review — errors cause rejection", "No dedicated agent", "Updates only by physical mail letter", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — New York Passport Agency is 30 miles via LIE or LIRR, appointments are scarce", "Life-or-death emergencies only", "Must prove travel within 72 hours", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "LIE commute home, book a JFK flight to London for next week, discover your passport expired? Hauppauge client meeting in Frankfurt confirmed with 4 days notice? Our emergency courier service submits via reserved agency slots — as fast as 24 hours.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Commack residents renew fast — no agency visit required for most renewals. Perfect for LIE corridor professionals, split-district families, and Hauppauge business travelers.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight from Commack", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Commack residents through every step — from the LIE corridor to Dix Hills — with clear instructions for the Commack Post Office on Jericho Turnpike.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance at Commack or Hauppauge post office", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your JFK departure via the LIE stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Commack family's split spring break — Cancun for some, Punta Cana for others — stays coordinated and on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports. Common for Commack professionals and newlyweds preparing for honeymoon international travel.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Hauppauge and Melville corridor executives, frequent business travelers, and professionals whose primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Spilled your morning coffee on your passport during the LIE traffic jam? Kids' juice box leaked in the family bag? Replacing a significantly damaged passport is faster than you think. We guide Central Suffolk travelers through the DS-11 replacement process.",
      bullets: ["Physical and liquid damage replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Popular with Commack families taking cruises from New York and Bayonne ports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: "Cruise-Ready",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Commack NY", description: "Urgent passport processing for Commack New York travelers with immediate departure needs from JFK, LaGuardia, or MacArthur Airport." },
    { name: "Expedited Passport Renewal Commack NY", description: "Fast passport renewal for Commack New York residents with a previously-issued passport." },
    { name: "First-Time Passport Commack NY", description: "New passport application services for Commack New York residents applying for their first passport." },
    { name: "Child Passport Commack NY", description: "Minor passport services for Commack New York families with children under 16." },
    { name: "Name Change Passport Commack NY", description: "Passport name correction after marriage, divorce, or legal name changes for Commack residents." },
    { name: "Second Passport Commack NY", description: "Second passport services for Commack frequent travelers and Hauppauge corridor professionals." },
  ],
  testimonials: [
    {
      name: "Stephanie M.",
      location: "Commack, NY — LIE corridor",
      rating: 5,
      text: "Needed my passport renewed for a business trip to Tokyo in 6 days. Fast Passport Center got it done in 5. The agent was incredibly helpful and even recommended the best photo spot near the Commack shopping center. Saved my client meeting.",
      service: "Passport Renewal",
    },
    {
      name: "Daniel L.",
      location: "Dix Hills, NY",
      rating: 5,
      text: "First-time passport for our family vacation to Italy. The team walked us through everything and made the acceptance clerk visit at the Hauppauge post office a breeze. Passport arrived in 4 days. Couldn't have asked for better guidance.",
      service: "New Passport",
    },
    {
      name: "Rachel P.",
      location: "Commack, NY — split district",
      rating: 5,
      text: "Lost my passport two weeks before our family trip to Cancun. With kids on different spring break schedules we were already stressed. Fast Passport Center handled the DS-64 and DS-11 forms and my replacement arrived in 3 days. Saved our family vacation.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Mark R.",
      location: "Hauppauge, NY",
      rating: 5,
      text: "Water-damaged passport from a commuting coffee spill during LIE traffic — completely soaked. Had a client meeting in London in 5 days. Fast Passport Center replaced it in 3 days with clear guidance through the damaged passport replacement process.",
      service: "Damaged Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "commack-1",
      name: "Commack Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2188 Jericho Turnpike",
      city: "Commack",
      state: "NY",
      zip: "11725",
      phone: "(631) 499-2335",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Commack — Jericho Turnpike",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Commack passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person. Saturday appointments fill 3+ weeks out during summer. Photo services on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "commack-2",
      name: "Hauppauge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "800 Veterans Memorial Highway",
      city: "Hauppauge",
      state: "NY",
      zip: "11788",
      phone: "(631) 582-7600",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Hauppauge — about 5 miles southeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger Suffolk County facility with extended Saturday hours until 1 PM. More appointment capacity than Commack Main. Photo services available. Best Saturday option in central Suffolk.",
      icon: "ri-mail-line",
    },
    {
      id: "commack-3",
      name: "Huntington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "126 East Main Street",
      city: "Huntington",
      state: "NY",
      zip: "11743",
      phone: "(631) 423-1964",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Huntington — about 6 miles northwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major North Shore Suffolk County passport acceptance facility. Photo services on-site. Good alternative when Commack Main is fully booked during peak season.",
      icon: "ri-mail-line",
    },
    {
      id: "commack-4",
      name: "Northport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 Main Street",
      city: "Northport",
      state: "NY",
      zip: "11768",
      phone: "(631) 261-4496",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Northport — about 7 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "North Shore passport acceptance facility. Smaller and often less crowded than Huntington Main. Convenient for Commack residents in the northern part of town.",
      icon: "ri-mail-line",
    },
    {
      id: "commack-5",
      name: "Hicksville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17 West John Street",
      city: "Hicksville",
      state: "NY",
      zip: "11801",
      phone: "(516) 433-2222",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Hicksville — about 10 miles southwest (Nassau County)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Nassau County passport acceptance facility with extended hours. Convenient for Commack residents who work in Nassau County or near the Nassau-Suffolk border.",
      icon: "ri-mail-line",
    },
    {
      id: "commack-6",
      name: "Suffolk County Clerk — Passport Services",
      type: "County Clerk Passport Acceptance",
      address: "310 Center Drive",
      city: "Riverhead",
      state: "NY",
      zip: "11901",
      phone: "(631) 852-2000",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Riverhead — Suffolk County Government (~40 miles east)",
      website: "https://www.suffolkcountyny.gov/",
      websiteLabel: "Suffolk County Clerk",
      notes: "County government passport acceptance facility. No photo services on-site — bring your own 2x2 photos. Appointments strongly recommended.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 30-mile trip to Manhattan via LIE or LIRR", fpc: "Most Commack travelers ship documents overnight — no commute required" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and commute", fpc: "Best price guarantee — 30–100% less than FedEx, Staples & resellers" },
    { feature: "Commack-Specific Guidance", agency: "Generic — no LIE corridor, split-district, or Hauppauge business park expertise", fpc: "Full LIE corridor, school district, and business park knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Split School District Spring Break Passport Chaos",
      description: "Commack families with children in different school districts often have two different spring break weeks. One child's passport is fine for week one while the other's expired for week two — and nobody checks until 10 days before the first departure. Coordinate passport validity across all family members when school calendars are released, not when you start packing.",
    },
    {
      icon: "ri-error-warning-line",
      title: "LIE Commuter Coffee Spill Damaged Passport",
      description: "Commack's LIE-based commuter culture means passports often live in briefcases and work bags alongside coffee cups, water bottles, and lunch containers. A spilled drink destroying a passport is surprisingly common — and a damaged passport requires in-person DS-11 replacement, not mail renewal.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Hauppauge/Melville Business Travel — Booking Before Passport Check",
      description: "Commack residents working in the Hauppauge and Melville office parks frequently book international corporate travel through company travel desks that do not flag passport expiration. Always self-check your passport before confirming any international business trip — company booking systems do not verify passport validity.",
    },
    {
      icon: "ri-error-warning-line",
      title: "First-Time Child Passport — Both Parents Rule Oversight",
      description: "Commack's concentration of young families means high volume of first-time child passport applications. Both parents must appear with the child or provide notarized DS-3053 consent. Coordinating two working parents to appear at the post office simultaneously is the #1 logistical challenge in Central Suffolk County.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming Commack Post Office Has Walk-In Availability",
      description: "The Commack Post Office on Jericho Turnpike is the closest acceptance facility but has very limited appointment capacity. During summer season (May–September), Saturday appointments fill 4+ weeks in advance. Always check availability at multiple facilities — Hauppauge, Huntington, and Northport are within 10 minutes.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date. Takes just a few minutes from your Commack home or Hauppauge office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist and document review guidance tailored to your destination." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Ship documents from the UPS Store on Jericho Turnpike or the Commack Post Office — no Manhattan visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you skip the 30-mile LIE drive and agency appointment scramble." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within your selected timeframe. No guessing, no hoping — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Commack?", a: "We offer Commack-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review documents before submission to catch errors — critical for LIE commuters and Hauppauge business travelers on compressed timelines." },
    { q: "Do I need to visit the Manhattan passport agency?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Commack, Hauppauge, or Huntington post office), then ship documents overnight. We handle the State Department submission. No 30-mile LIE drive to Manhattan required." },
    { q: "Where can I get passport acceptance near Commack?", a: "The Commack Post Office on Jericho Turnpike is closest. Nearby options include Hauppauge Post Office (5 miles southeast, extended Saturday hours), Huntington Post Office (6 miles northwest), and Northport Post Office (7 miles north). We maintain an updated list." },
    { q: "Can you help with split school district passport coordination?", a: "Yes — many Commack families have children in different school districts with staggered spring breaks. We routinely help families process multiple passports across different timelines and destinations in a single coordinated effort." },
    { q: "What is the best price for expedited passport service in Commack?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "Can you help with Hauppauge business park corporate travel?", a: "Yes — we regularly assist Hauppauge and Melville corridor professionals with expedited passports for international meetings, client visits, and corporate conferences. The 1–2 week booking windows common in corporate travel are exactly what courier-speed service addresses." },
    { q: "Which airport should I use from Commack?", a: "JFK (30 miles via LIE) is the primary international gateway. LaGuardia (25 miles) handles domestic connections and Caribbean routes. MacArthur Airport (ISP, 18 miles) is closest but has limited international service — mostly Florida connections and seasonal Caribbean." },
    { q: "What documents do Commack applicants need?", a: "New passport: certified birth certificate, photo ID, DS-11 form, passport photo. Renewal: DS-82 form, current passport, passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, photos. We provide a Commack-specific checklist." },
    { q: "Can I get a passport photo in Commack?", a: "Yes — CVS Pharmacy, Walgreens, UPS Store, and FedEx Office throughout Commack, Hauppauge, Dix Hills, and Huntington. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "Can I take the LIE to the Manhattan passport agency?", a: "The New York Passport Agency is about 30 miles via LIE — technically under an hour without traffic. But appointments are extremely scarce and reserved for life-or-death emergencies. Our courier service provides faster results without the appointment scramble and traffic uncertainty." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Commack Residents",
    intro: "Commack's position at the geographic crossroads of Central Suffolk County — combined with the LIE corridor, Hauppauge business park, and split school district dynamics — creates passport timing challenges that standard post office processing cannot handle.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "JFK — via Long Island Expressway",
        subtitle: "30 miles southwest — the primary international gateway",
        description: "JFK is the main international airport for Commack residents, with direct flights to London, Paris, Frankfurt, and worldwide destinations. The 30-mile drive via the LIE is straightforward but unpredictable — rush-hour traffic can extend travel time beyond 90 minutes. Commack LIE commuters booking international flights from Manhattan offices often discover passport issues the week before departure and need courier-speed processing.",
        tip: "Check your passport validity from your desk before booking international flights — not during your LIE commute home. An expired passport discovered Wednesday evening with a Friday JFK departure leaves zero margin for standard processing.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ISP — Long Island MacArthur Airport",
        subtitle: "18 miles southeast — closest and most convenient",
        description: "MacArthur Airport is the closest option to Commack and the preferred choice for families and leisure travelers. ISP serves Florida, seasonal Caribbean routes, and major U.S. hubs. The convenience of a 20-minute drive versus 45+ minutes to JFK makes ISP the natural choice for Commack families — but limited international service means business travelers still need JFK for worldwide destinations.",
        tip: "Always check ISP's route map before defaulting to JFK. You might save yourself the LIE traffic and JFK parking fees with a direct ISP flight to Florida or a seasonal Caribbean route. But verify passport validity before any ISP departure — the airport has zero passport services on-site.",
      },
      {
        icon: "ri-building-2-line",
        title: "Hauppauge & Melville Business Corridors",
        subtitle: "Long Island's largest office parks — minutes from Commack",
        description: "Commack borders both the Hauppauge Industrial Park and the Melville business corridor. These office parks employ thousands of professionals whose corporate travel is characterized by compressed booking-to-departure windows. A client meeting in Frankfurt confirmed with 7 days notice, a London trade show with 10 days to prepare — these are standard corporate travel timelines that standard post office processing (8–11 weeks) completely fails to accommodate.",
        tip: "Corporate travelers in the Hauppauge-Melville corridor should treat passport validity as a standing professional requirement — not a per-trip checklist item. A current passport is as essential as a working laptop for international business travel.",
      },
      {
        icon: "ri-school-line",
        title: "Split School District Spring Break Coordination",
        subtitle: "Commack straddles Smithtown and Huntington districts with different calendars",
        description: "Commack's unique position spanning the Smithtown and Huntington school districts creates families with children on different academic calendars. Spring break in one district may be the last week of March while the other is mid-April. This staggered schedule means families often have two international travel windows and two sets of passport deadlines — creating a passport coordination challenge that requires proactive planning and fast processing when things go wrong.",
        tip: "When school calendars are released in August, immediately check all family members' passport expiration dates against both spring break weeks. Order renewals in September — not in February when acceptance facilities are overwhelmed with peak-season demand.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Commack & the Central Suffolk Passport Infrastructure Gap",
      description: "Commack sits at the center of one of Long Island's most densely populated suburban corridors — yet there is no premium passport processing infrastructure within 30 miles. The Commack Post Office has limited appointment capacity, and the Manhattan Passport Agency is technically reachable via LIE but practically inaccessible due to appointment scarcity. This infrastructure gap makes courier-speed service the only viable option for Commack travelers with international departures within 4 weeks.",
    },
  },
  destinations: {
    title: "Where Commack Travelers Go — And Why Passports Get Urgent",
    intro: "Commack's blend of LIE corridor professionals, split-district families, and Hauppauge business park employees creates an international travel profile that spans corporate destinations, family resort vacations, and multi-generational heritage trips.",
    stats: [
      { stat: "30%", label: "of Commack expedited requests are corporate or business-related — Hauppauge/Melville corridor international meetings with 1–3 week notice" },
      { stat: "2–4 Weeks", label: "average lead time Commack families have from vacation booking to international departure" },
      { stat: "Mar–Apr", label: "peak season when split school district spring breaks, corporate Q1 travel, and winter escape vacations collide" },
      { stat: "36 Hours", label: "shortest turnaround for a Hauppauge executive departing to a London client meeting from JFK" },
    ],
    destinations: [
      { name: "Italy", context: "Commack family heritage trips, Rome and Florence vacations, multi-generational European travel", urgency: "Summer bookings made 3–6 months ahead but passport issues surface 2–4 weeks before fixed departure dates", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "London corporate meetings from Hauppauge/Melville corridor, JFK direct flights, financial sector travel", urgency: "Client meetings with 1–2 week booking windows and unmovable dates", icon: "ri-map-pin-2-line" },
      { name: "Mexico", context: "Cancun and Riviera Maya family resort vacations, spring break trips from split-district families", urgency: "Spring break bookings made months ahead but passport checks delayed until 2–3 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Frankfurt corporate meetings, Hauppauge business park supplier visits, trade show travel", urgency: "Trade show dates are fixed and published months ahead — passport issues discovered 2 weeks before", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Bahamas", context: "Cruise departures from NYC and Bayonne, family resort vacations, winter escapes", urgency: "Winter cruise bookings checked for passport validity 2–3 weeks before sailing", icon: "ri-map-pin-2-line" },
      { name: "Ireland", context: "Commack Irish-heritage family trips, Dublin and Galway travel, JFK direct flights", urgency: "Summer heritage trips with fixed family reunion dates — unmovable once booked", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Long Island", route: "/long-island" },
      { name: "Smithtown", route: "/smithtown" },
      { name: "Huntington", route: "/huntington" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Commack", address: "2188 Jericho Turnpike, Commack, NY 11725", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Commack", address: "5001 Jericho Turnpike, Commack, NY 11725", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "The UPS Store — Commack", address: "6500 Jericho Turnpike, Commack, NY 11725", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "FedEx Office — Hauppauge", address: "800 Veterans Memorial Highway, Hauppauge, NY 11788", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "CVS Pharmacy — Dix Hills", address: "696 E Jericho Turnpike, Huntington Station, NY 11746", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Hauppauge", address: "601 Veterans Memorial Highway, Hauppauge, NY 11788", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Kings Park", address: "59 Indian Head Road, Kings Park, NY 11754", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "FedEx Office — Commack", address: "2150 Jericho Turnpike, Commack, NY 11725", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Hauppauge",
      address: "2500 Nesconset Highway, Hauppauge, NY 11788",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Major Suffolk County DMV office serving Central Suffolk including Commack, Hauppauge, Smithtown, and Dix Hills. Closest DMV to Commack. REAL ID available. Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Huntington",
      address: "200 East Main Street, Huntington, NY 11743",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Suffolk County DMV office serving North Shore communities. Alternative option for Commack residents. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ISP",
      name: "Long Island MacArthur Airport",
      distance: "About 18 miles southeast of Commack",
      address: "100 Arrival Avenue, Ronkonkoma, NY 11779",
      note: "Closest airport to Commack. Flights to Florida, seasonal Caribbean service, and major U.S. hubs. 20-minute drive via the LIE.",
      flightUrl: "https://www.macarthurairport.com/",
      flightLabel: "MacArthur Airport",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "About 30 miles southwest of Commack",
      address: "JFK Access Road, Queens, NY 11430",
      note: "Primary international gateway. Direct flights to London, Frankfurt, and worldwide destinations. Accessible via LIE from Commack.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "About 25 miles west of Commack",
      address: "94th Street, Queens, NY 11371",
      note: "Domestic-focused airport with Caribbean routes. Popular for connections to Miami and Atlanta.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LaGuardia Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Commack residents born locally can also contact the Smithtown or Huntington Town Clerk depending on school district.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Records. Required for estate and legal matters in Suffolk County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Smithtown Town Clerk or Huntington Town Clerk — depending on which side of the school district line the ceremony took place.",
      url: "https://www.suffolkcountyny.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Suffolk County Supreme Court Clerk in Riverhead. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default commackConfig;